<template>
  <donut-chart-card :size="size" :title="title" :value="data" unit="개소" :init-total="total" :isMoveWrite="isMoveWrite" :orientation="orientation" @detail="onClickDetail" @write="onClickWrite" @item="onClickItem"></donut-chart-card>
</template>

<script>
import DonutChartCard from "@/components/DonutChartCard";

export default {
  name: "DonutChart01",
  components: { DonutChartCard },
  props: {
    dataType: "detail" | "field" | "address" | "field_cat1" | "company" | "project",
    size: String,
    reloadCount: Number,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait",
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    title() {
      if (this.projectId) {
        if (`${this.projectId}` === '5') return "시설물 현황";
        else return "사업장 현황";
      }
      return "관리 현황";
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType(/*value*/) {
      this.loadGraph();
    },
    reloadCount() {
      this.loadGraph();
    },
  },
  data() {
    return {
      graphId: 1,
      isMoveWrite: false,
      data: [{ label: "데이터 없음", value: 0 }],
      total: -1,
    };
  },
  async mounted() {
    await this.loadGraph();
  },
  methods: {
    async loadGraph() {
      let projectIds = [];
      if (this.projectId) {
        projectIds = [this.projectId];
      } else {
        projectIds = [2, 3, 4, 5];
      }

      const donutData = await this.$store.dispatch("summary/LOAD_DONUT_35", {
        projectIds,
        depth: 1,
      });
      // console.log('donut01', this.getLevel, {type: this.dataType, donutData});

      let tmpData = {};
      const parsedData = [];

      switch (this.dataType) {
      case "project":
        tmpData = donutData.project;
        break;
      case "company":
        tmpData = donutData.company;
        break;
      case "field":
        tmpData = donutData.field;
        break;
      case "field_cat1":
        tmpData = donutData.field;
        break;
      case "detail":
        // if (this.getLevel === 3 || this.getLevel === 4) {
        //   tmpData = donutData.field;
        // } else {
        tmpData = donutData.company;
        // }
        break;
      }
      // console.log(this.dataType, this.getLevel, tmpData, donutData);

      // 현재 년도
      const currentYear = new Date().getFullYear();

      let rowSum = 0;
      if (Object.keys(tmpData).length > 0) {
        for (const key of Object.keys(tmpData)) {
          if (tmpData[key].yearly.total > 0) {
            parsedData.push({
              label: tmpData[key].label,
              value: tmpData[key].yearly[currentYear],
            });
            rowSum += tmpData[key].yearly[currentYear];
          }
        }

        // parsedData를 value 내림차순 정렬한다
        parsedData.sort((a, b) => {
          return b.value - a.value;
        });

        this.data = parsedData;
      }

      // 합계는, 전체 분야 데이터에서 가져온다
      let projectTotal = 0;

      for (const projectItem of donutData.project) {
        // 현재 년도에서 합계를 가져온다
        projectTotal += projectItem.yearly[currentYear];
      }

      if ((this.getLevel === 3 || this.getLevel === 4) && this.dataType === "detail") {
        this.total = rowSum;
      } else {
        this.total = projectTotal;
      }
    },

    onClickDetail() {
      const projectId = this.$route.params.proj_id;
      const graphId = this.graphId;
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`);
      } else {
        this.$router.push(`/graph-detail/${graphId}`);
      }
    },
    onClickWrite() {
      const proj_id = this.$route.params.proj_id;
      this.$router.push({ name: "field-workplace-create", params: { proj_id } });
    },
    onClickItem() {
      if (Number(`${this.projectId}`) === 2) {
        this.$router.push("/project/2/field/info/type-a");
      } else if (Number(`${this.projectId}`) === 3) {
        this.$router.push("/project/3/field/info/type-b");
      } else if (Number(`${this.projectId}`) === 4) {
        this.$router.push("/project/4/field/info/type-c");
      } else if (Number(`${this.projectId}`) === 5) {
        this.$router.push("/project/5/field/info/type-d");
      }
    },
  },
};
</script>

<style scoped></style>
